import moment from 'moment'
import React, { useState } from 'react'
import { GoArrowDownRight, GoArrowUpRight } from 'react-icons/go'
import { IoArrowBack, IoArrowForward } from 'react-icons/io5'


const RecentOrdersList = ({ orders }) => {
  return (
    <div className="flex flex-col">
      <div className="-m-1.5 overflow-x-auto">
        <div className="p-1.5 min-w-full inline-block align-middle">
          <div className="bg-white dark:bg-dark border dark:border-border-dark dark:text-white bg-clip-border rounded-lg shadow-sm overflow-hidden ">
            <div className="bg-white dark:bg-dark p-4">
              <h1 className='text-lg font-bold'>Recent Orders</h1>
            </div>
            <table className="min-w-full divide-y divide-gray-200 dark:divide-border-dark">
              <thead className="bg-transparent dark:bg-secondaryDark">
                <tr>
                  <th scope="col" className="px-6 py-3 text-start text-sm font-light text-gray-500  capitalize hover:text-border-dark dark:hover:text-border-dark  ">Order id</th>
                  <th scope="col" className="px-6 py-3 text-start text-sm font-light text-gray-500  capitalize hover:text-border-dark dark:hover:text-border-dark  ">Aggregator</th>
                  <th scope="col" className="px-6 py-3 text-start text-sm font-light text-gray-500 capitalize hover:text-black dark:hover:text-border-dark ">Phone number</th>
                  <th scope="col" className="px-6 py-3 text-start text-sm font-light text-gray-500 capitalize hover:text-black dark:hover:text-border-dark ">Price(GHS)</th>
                  <th scope="col" className="px-6 py-3 text-start text-sm font-light text-gray-500 capitalize hover:text-black dark:hover:text-border-dark ">Quantity</th>
                  <th scope="col" className="px-6 py-3 text-start text-sm font-light text-gray-500 capitalize hover:text-black dark:hover:text-border-dark ">Order Date</th>
                  <th scope="col" className="px-6 py-3 text-end text-sm font-light text-gray-500  capitalize hover:text-black ">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y bg-white divide-gray-200 dark:bg-dark dark:divide-border-dark">
                {orders?.map((order, index) => (
                  <tr key={index} className="text-[13px]">
                    <td className="px-6 hover:bg-gray-50 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-neutral-200 flex flex-row items-center gap-2">
                      {order?.order_id || "N/A"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {`${order?.order_user?.firstname} ${order?.order_user?.lastname}`}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {order?.order_user.phone || "N/A"}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap font-light">
                      {order?.order_price || "N/A"}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap font-light">
                      {order?.order_quantity || "N/A"}
                    </td>

                    <td className="px-6 py-4 capitalize whitespace-nowrap font-light">
                      {moment(order?.order_date).format("dddd MMM Do YYYY")}
                    </td>

                    <td className="px-6 py-4 capitalize whitespace-nowrap font-light">
                      {order?.order_status || "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RecentOrdersList